import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2949bdba")

_pushScopeId("data-v-2949bdba")
const _hoisted_1 = { class: "toc_ui__ecu_title-success" }
const _hoisted_2 = { class: "ecu-success" }
const _hoisted_3 = { class: "ecu-success-icon" }
const _hoisted_4 = { class: "ecu-fail-icon" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "toc_ui__ecu_body"
}
const _hoisted_7 = { class: "toc_ui__ecu_title-fail" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("查询失败")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "toc_ui__ecu_main",
    id: _ctx.state.ecuId
  }, [
    (Object.keys(_ctx.state.ecuInfo).length !== 0)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "toc_ui__ecu_body",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
        }, [
          _createVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.state.isJiaGou? '【加购】' : '') + "ECU检测 ", 1),
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode("img", {
                  src: require('@/assets/toc/ecu-normal.png')
                }, null, 8, ["src"]),
                _createTextVNode(_toDisplayString(_ctx.state.normalNum) + "项", 1)
              ]),
              _createVNode("span", _hoisted_4, [
                _createVNode("img", {
                  src: require('@/assets/toc/ecu-abnormal.png')
                }, null, 8, ["src"]),
                _createTextVNode(_toDisplayString(_ctx.state.abnormalNum) + "项", 1)
              ]),
              _hoisted_5
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.state.isJiaGou? '【加购】' : '') + "ECU检测 ", 1),
            _createVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.failView && _ctx.failView(...args)))
            }, [
              _hoisted_8,
              _createVNode("img", {
                src: require('@/assets/toc/ecu-fail.png')
              }, null, 8, ["src"])
            ])
          ])
        ])),
    _hoisted_9
  ], 8, ["id"])), [
    [_vShow, _ctx.state.reportMsg.Rp499() || _ctx.state.reportMsg.Rp699() || _ctx.state.reportMsg.RpFJ() || _ctx.state.isJiaGou]
  ])
})